export const imageUrls = {
  hero: "/capability-care.jpg",
  build: "/capability-build.jpg",
  refresh: "/capability-refresh.jpg",
  motion: "/capability-motion.jpg",
};

export const manifestoChapters = [
  ["01", "Death to digital monotony", "No recycled layouts, no stock-template energy, no website that could belong to anybody."],
  ["02", "Motion as meaning", "Every reveal, hover, and transition exists to guide attention and make the brand easier to feel."],
  ["03", "Uncompromising speed", "Beautiful pages still need to load instantly, read clearly, and work flawlessly on every phone."],
  ["04", "Conversion by craft", "Premium design builds trust before the first call, then turns that trust into action."],
];

export const services = [
  {
    title: "Full custom site build",
    label: "01 / Build",
    image: imageUrls.build,
    text: "Strategy, structure, copy polish, design, engineering, and launch handled as one sharp system.",
  },
  {
    title: "Modernization refresh",
    label: "02 / Refresh",
    image: imageUrls.refresh,
    text: "Keep what works, replace what embarrasses you, and bring the entire experience into 2026.",
  },
  {
    title: "Motion & interactive moments",
    label: "03 / Motion",
    image: imageUrls.motion,
    text: "Kinetic heroes, scroll choreography, canvas scenes, and micro-interactions with a clear purpose.",
  },
  {
    title: "Continuous care",
    label: "04 / Care",
    image: imageUrls.hero,
    text: "Hosting, updates, edits, monitoring, and a direct line when something needs attention.",
  },
];

const customWebsiteFeatures = ["Bespoke architecture & design", "Kinetic hero interactions", "Copywriting polish", "Lead funnel setup", "Launch concierge"];

export const pricingTiers = [
  {
    name: "Website refresh",
    price: "$500",
    billing: "one-time commitment",
    description: "Already have a site that's outdated or embarrassing? I'll rebuild it to look and load like it's actually 2026, keeping what works.",
    features: ["Complete UI/UX overhaul", "Mobile-first optimization", "Performance upgrade", "SEO preservation", "Rapid delivery"],
    cta: "Refresh my site",
  },
  {
    name: "New website",
    price: "$800",
    billing: "one-time commitment",
    description: "A custom-built site designed around your business — your services, your service area, your customers. Mobile-friendly from the ground up.",
    features: customWebsiteFeatures,
    cta: "Build from scratch",
    popular: true,
  },
  {
    name: "Ongoing care",
    price: "$50",
    billing: "per month, no lock-in",
    description: "Hosting, seasonal promotions, monthly updates, and ongoing improvements that keep your site fresh, fast, and performing. No contracts longer than a month.",
    features: ["Cloud hosting", "Seasonal promotions", "Monthly site updates", "Ongoing improvements", "Cancel anytime"],
    cta: "Add ongoing care",
  },
  {
    name: "Nonprofit Rate",
    price: "$200",
    billing: "one-time nonprofit rate",
    description: "A discounted custom website for registered 501(c)(3) organizations, local charities, and churches, built with the same care as the full New Website package.",
    features: customWebsiteFeatures,
    cta: "Start nonprofit build",
  },
];

export const faqs = [
  ["How long does a typical website build take?", "Most focused business websites launch in one to two weeks once content and feedback move quickly. Larger custom features receive a clear timeline before work begins."],
  ["What technology stack do you build on?", "Tybra builds modern, fast React experiences with clean backend integrations where needed. The stack is selected around your goals rather than forced from a template."],
  ["Do I own 100% of my site and code after launch?", "Yes. You own the finished website, content, and codebase. Ongoing Care is optional and never used to hold your site hostage."],
  ["How does the $50/month Ongoing Care work?", "It covers hosting, routine updates, small content or design edits, monitoring, and direct support. It runs month to month, and you can cancel anytime."],
  ["What if I need bookings or e-commerce?", "Those can be scoped as custom additions. The discovery call is the fastest way to map the feature, cost, and launch path."],
  ["How does the Nonprofit Rate discount work?", "Qualifying registered 501(c)(3) organizations, local charities, and churches can get the full custom website package for $200. Tybra Digital offers the discount because community organizations deserve a credible, modern web presence without pulling money away from their mission."],
  ["How about custom mobile apps?", "Yes. Custom mobile apps are available upon request and scoped separately from a website. We can discuss native apps, cross-platform apps, or a progressive web app based on what your customers actually need."],
];
